import React from "react";
import "./App.css";
import FullPageSlider from "./components/FullPageSlider";

const App: React.FC = () => {
  return (
    <div className="App">
      <FullPageSlider />
    </div>
  );
};

export default App;
